
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 250 45.6","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M69 11.7c-9.2 0-16.7 7.5-16.7 16.7S59.8 45.2 69 45.2s16.7-7.5 16.7-16.7S78.3 11.7 69 11.7zm0 28.4c-6.4 0-11.7-5.2-11.7-11.7S62.6 16.8 69 16.8 80.7 22 80.7 28.4 75.5 40.1 69 40.1zM84.4 0H53.5v5.3h30.8V0zm148.8 33.5c9.2 0 16.7-7.5 16.7-16.7S242.5 0 233.2 0c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.8 16.7 16.8zm0-28.4c6.4 0 11.7 5.2 11.7 11.7s-5.2 11.7-11.7 11.7c-6.4 0-11.7-5.2-11.7-11.7s5.3-11.7 11.7-11.7zm-15.3 40.1h30.8v-5.3h-30.8v5.3zM118 .1h-5.3v45.5H137v-5.3h-19V.1zM11 .2L0 .1v45.5h5.3V32.2h5.8c8.8 0 16-7.2 16-16C27 7.4 19.9.2 11 .2zm.1 26.7c-.4 0-.7.1-1.1 0H5.3V5.5h5.9c5.9 0 10.7 4.8 10.7 10.7S17 26.9 11.1 26.9zM177.6.2l-11-.1v45.5h5.3V32.2h5.8c8.8 0 16-7.2 16-16-.1-8.8-7.3-16-16.1-16zm.1 26.7c-.4 0-.7.1-1.1 0h-4.7V5.5h5.9c5.9 0 10.7 4.8 10.7 10.7s-4.9 10.7-10.8 10.7z","fill":"#a5a7a9"}})])
          )
        }
      }
    